export const getRuedaData = () => ({
  name: "Rueda",
  country: "Espagne",
  description: "Rueda est une région viticole de Castille-et-León, dans le centre de l'Espagne, produisant principalement des vins blancs secs et aromatiques à base de Verdejo. Cette région bénéficie d'un climat continental sec et de sols calcaires qui donnent aux vins leur caractère distinctif.",
  type: "region",
  mapAreas: [
    { region: "Rueda", x: 35, y: 45, color: "#4B164C", size: 5 }
  ],
  statistics: {
    totalArea: "15,000 ha",
    production: "1.2 million hectolitres",
    appellations: "1 DO",
    villages: "53 communes",
    exportPercentage: "30%"
  },
  characteristics: {
    climate: "Climat continental sec avec des hivers froids et des étés chauds",
    soil: "Sols calcaires et argileux, très drainants",
    viticulture: "Viticulture traditionnelle, vendanges manuelles, rendements limités"
  },
  wineStyles: {
    white: "Vins blancs secs et aromatiques, avec une fraîcheur et une minéralité caractéristiques",
    red: "Vins rouges fruités et équilibrés, produits en petites quantités",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif"
  },
  history: "La viticulture dans la région de Rueda remonte à l'époque romaine. Au Moyen Âge, les monastères ont développé la viticulture. Le XXe siècle a vu l'émergence de l'appellation DO Rueda. Aujourd'hui, la région est reconnue pour ses vins blancs de qualité.",
  foodPairing: "Poissons, fruits de mer, volailles, fromages, cuisine castillane traditionnelle",
  subregions: {
    "rueda": {
      name: "Rueda",
      description: "Zone centrale de Rueda produisant des vins blancs secs et aromatiques, avec une forte identité terroir.",
      characteristics: {
        climate: "Climat continental sec",
        soil: "Sols calcaires et argileux",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Verdejo", "Sauvignon Blanc", "Viura"],
        red: ["Tempranillo", "Cabernet Sauvignon", "Merlot"]
      },
      wineStyles: {
        "verdejo-rueda": "Vins blancs secs et aromatiques",
        "sauvignon-rueda": "Vins blancs secs et frais"
      },
      foodPairing: "Poissons, fruits de mer, volailles, cuisine traditionnelle"
    },
    "medina-del-campo": {
      name: "Medina del Campo",
      description: "Zone méridionale de Rueda produisant des vins blancs équilibrés et des vins rouges fruités.",
      characteristics: {
        climate: "Climat continental tempéré",
        soil: "Sols calcaires et sableux",
        viticulture: "Viticulture traditionnelle, rendements limités"
      },
      grapeVarieties: {
        white: ["Verdejo", "Sauvignon Blanc", "Viura"],
        red: ["Tempranillo", "Cabernet Sauvignon", "Merlot"]
      },
      wineStyles: {
        "verdejo-medina": "Vins blancs équilibrés et fruités",
        "rueda-rouge": "Vins rouges fruités et équilibrés"
      },
      foodPairing: "Viandes blanches, poissons, fromages, cuisine traditionnelle"
    },
    "nava-del-rey": {
      name: "Nava del Rey",
      description: "Zone occidentale de Rueda produisant des vins blancs et rouges de qualité, avec une forte identité locale.",
      characteristics: {
        climate: "Climat continental avec influence atlantique",
        soil: "Sols calcaires et argileux",
        viticulture: "Viticulture traditionnelle, vignobles en coteaux"
      },
      grapeVarieties: {
        white: ["Verdejo", "Sauvignon Blanc", "Viura"],
        red: ["Tempranillo", "Cabernet Sauvignon", "Merlot"]
      },
      wineStyles: {
        "verdejo-nava": "Vins blancs secs et structurés",
        "nava-rouge": "Vins rouges fruités et équilibrés"
      },
      foodPairing: "Viandes blanches, poissons, fromages, cuisine traditionnelle"
    },
    "serrada": {
      name: "Serrada",
      description: "Zone orientale de Rueda produisant des vins blancs frais et aromatiques.",
      characteristics: {
        climate: "Climat continental sec",
        soil: "Sols calcaires et sableux",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Verdejo", "Sauvignon Blanc", "Viura"]
      },
      wineStyles: {
        "verdejo-serrada": "Vins blancs frais et aromatiques",
        "serrada-blanc": "Vins blancs secs et minéraux"
      },
      foodPairing: "Poissons, fruits de mer, volailles, cuisine castillane"
    }
  }
}); 